import { Navigate } from "react-router-dom";

import { useMyPermessi } from "@/hooks/usePermessi";
import { DashboardPage } from "@/pages/DashboardPage";

/**
 * Landing della rotta `/`: manda dove dice **la configurazione del ruolo**
 * (`auth.ruolo_atterraggio`), non un elenco di ruoli scritto qui.
 *
 * ⚠️ Fino al 30-08-2026 questo file conteneva tre `if` sul ruolo — logistica sul
 * calendario, presidenza e management sul loro modulo, viewer e commerciale su
 * «non disponibile» — **gemelli** di altrettanti elenchi in `nav-config.ts`.
 * Erano due sorgenti che dovevano concordare: la barra evidenziava una voce e
 * questo file decideva dove andavi davvero. Ora leggono la stessa risposta
 * (`GET /me/permessi`), quindi non possono più divergere.
 *
 * Il default è la Dashboard: chi non ha una riga atterra lì, com'era per
 * chiunque non fosse nominato in quegli `if`.
 *
 * Vale anche con «Vedi come → Logistica»: l'header `X-Vedi-Come` è sempre
 * inviato, quindi i permessi (e l'atterraggio dentro di essi) sono quelli
 * dell'utente impersonato — ed è ciò che serve per collaudarlo.
 *
 * Nota storica sulla dashboard di Marina: ne aveva una sua
 * (`DashboardLogistica`, giugno 2026), tolta col calendario perché leggeva il
 * modello di M3 di allora e mostrava «0 camion oggi · 0 domani · 0 settimana».
 * Il calendario è la stessa domanda fatta ai dati veri.
 */
export function DashboardLanding() {
  const { data: perms, isLoading } = useMyPermessi();

  // In attesa dei permessi: niente redirect (evita il flash); la pagina gestisce
  // i propri stati di caricamento.
  if (!isLoading && perms) {
    const dove = perms.atterraggio?.path ?? "/";
    // Redirect e non render diretto: la rotta dev'essere quella vera, altrimenti
    // la barra non saprebbe quale voce evidenziare.
    if (dove !== "/") {
      return <Navigate to={dove} replace />;
    }
  }

  return <DashboardPage />;
}
